<template>
  <el-dialog title="創建標籤" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" class="dialogEdit">
    <el-form :model="form" >
      <el-form-item label="語言" prop="language">
        <el-select v-model="form.language" :disabled="language_disabled">
          <el-option v-for="item in languages" :key="item.name" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="標籤名稱" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off">
          </el-input>
      </el-form-item>
      <el-form-item label="排序" :label-width="formLabelWidth">
        <el-input v-model="form.sort" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="是否熱話" :label-width="formLabelWidth">
        <el-switch v-model="form.ishot"></el-switch>
      </el-form-item>
      <el-form-item label="首頁顯示" :label-width="formLabelWidth">
        <el-switch v-model="form.ishome"></el-switch>
      </el-form-item>
      <el-form-item label="是否顯示" :label-width="formLabelWidth">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit">確 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "compare_dialog",
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: 30,
      language_disabled: false, 
      languages: [{id: 'tw', name: '中文繁體'}, {id: 'cn', name: '中文简体'}, {id: 'en', name: '英文'}],
      form: {
        name: "",
        name_cn: "",
        name_en: "",
        language: "tw",
        status: true,
        sort:0,
      }
    };
  },
  methods: {
    show(value, language, disabled) {
      this.dialogVisible = true;
      if (value !== undefined && value !== null) {
        this.form = Object.assign({}, value);
        this.form.language = language;
        this.language_disabled = disabled;
        this.form.status = this.form.status == 1 ? true : false;
        this.form.ishot = this.form.ishot == 1 ? true : false;
        this.form.ishome = this.form.ishome == 1 ? true : false;
      } else {
        this.language_disabled = disabled;
        this.form = { name: "", language: language, status: true,sort:0,ishot:true,ishome:false };
      }
    },
    onSubmit() {
      var self = this;
      let params = Object.assign({}, this.form);

      this.$http.post("/admin/tags/edit", params).then(res => {
        console.log("r1111es:",res.data);
        self.$emit("sucess",res.data);
        this.dialogVisible = false;
      });
    }
  }
};
</script>
<style lang="less">
.dialogEdit{
    text-align:left;
    
}
</style>